import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchMySlowMovingGames = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.mySlowMovingGames;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/my-slow-moving-games.api.js